import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/layout/SmoothScroll";
import { LeadModalProvider } from "@/components/common/LeadModal";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Groupe from "@/pages/Groupe";
import FormationsIndex from "@/pages/FormationsIndex";
import FormationCategory from "@/pages/FormationCategory";
import FormationDetail from "@/pages/FormationDetail";
import Financements from "@/pages/Financements";
import Centres from "@/pages/Centres";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Resultats from "@/pages/Resultats";
import DocumentsUtiles from "@/pages/DocumentsUtiles";
import Cookies from "@/pages/Cookies";
import Signalement from "@/pages/Signalement";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <LeadModalProvider>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/le-groupe" element={<Groupe />} />
              <Route path="/nos-formations" element={<FormationsIndex />} />
              <Route path="/nos-formations/:category" element={<FormationCategory />} />
              <Route path="/nos-formations/:category/:slug" element={<FormationDetail />} />
              <Route path="/financements" element={<Financements />} />
              <Route path="/nos-centres" element={<Centres />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
              <Route path="/resultats" element={<Resultats />} />
              <Route path="/documents-utiles" element={<DocumentsUtiles />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/signalement" element={<Signalement />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </SmoothScroll>
        <Toaster position="top-right" richColors />
      </LeadModalProvider>
    </BrowserRouter>
  );
}

export default App;
